import { billOfMaterialsTemplateBindingIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";

export const rejectBomTemplateFlows = {
  name: "rejectBomTemplateFlows" as const,
  input: z.object({
    bindingId: billOfMaterialsTemplateBindingIdFormat.schema,
    flowKeys: z.array(z.string()).min(1),
  }),
  output: z.object({}),
};
